<template>
  <div
    :class="[
      show ? 'show' : '',
      'clear',
    ]"
  >
    <div
      :class="[
        show ? 'show' : '',
        'card',
      ]"
    >
      <div class="card-header">
        <label class="header">Service Performed</label>
      </div>

      <div class="card-content">
        <div class="input-sub-container">
          <div class="input-label">
            Date
          </div>
          <Datepicker
            v-model="date"
            @input="$emit('input', $event)"
          />
        </div>
        <div class="input-sub-container">
          <div class="input-label">
            Technician Name
          </div>
          <input
            v-model="technicianName"
            class="technician-input"
            type="text"
            maxlength="50"
          >
        </div>
        <div class="input-sub-container">
          <div class="input-label">
            Work Performed
          </div>
          <textarea
            v-model="workPerformed"
            class="desc-text"
            maxlength="1024"
          />
        </div>
      </div>

      <div class="card-footer">
        <button
          class="cancel-btn"
          @click="hide(); reset()"
        >
          Cancel
        </button>
        <button
          :class="[
            'save-btn',
            !(date && workPerformed && technicianName) ? 'disable' : '',
          ]"
          @click="serviceAlerts({ date, technicianName, workPerformed }); reset()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'v-calendar/lib/components/date-picker.umd';

export default {
  name: 'WorkPerformed',
  components: {
    Datepicker,
  },
  props: {
    show: Boolean,
    hide: Function,
    serviceAlerts: Function,
  },
  data() {
    return {
      date: new Date(),
      technicianName: '',
      workPerformed: '',
    };
  },
  methods: {
    reset() {
      this.date = new Date();
      this.technicianName = '';
      this.workPerformed = '';
    },
  },
};
</script>

<style lang="scss">

.clear {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  align-items: center;
  justify-content: center;
  z-index: 5;
  transform: scale(0);
  &.show {
    display: flex;
    transform: scale(1);
  }
  .card {
    position: relative;
    height: 500px;
    width: 500px;
    background-color: $WHITE;
    border-radius: 10px;
    transform: scale(0);
    transition: all .3s;
    &.show {
      transform: scale(1);
    }
    .card-header {
      padding: 10px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      width: 100%;
      background-color: $CONTENTGRAY;
      font-size: 18px;
      font-weight: 600;
      color: $WHITE;
      text-transform: uppercase;
    }
    .card-content {
      height: 400px;
      width: 100%;
      border-bottom: 1px solid $N10;
      padding: 20px;
      display: grid;
      grid-auto-flow: row;
      .input-sub-container {
        .input-label {
          text-transform: uppercase;
          color: $CONTENTGRAY;
          font-weight: 600;
          font-size: 13px;
        }
        .technician-input {
          height: 35px;
          border: 1px solid #cbd5e0;
          border-radius: 3px;
          padding-left: 12px;
          width: 100%;
          &:focus {
            box-shadow:0 5px 10px -8px $CONTENTGRAY;
          }
        }
        .desc-text {
          height: 150px;
          resize: none;
          border: 1px solid #cbd5e0;
          border-radius: 3px;
          width: 100%;
          padding: 10px;
          outline: none;
          &:focus {
            box-shadow:0 5px 10px -8px $CONTENTGRAY;
          }
        }
      }
    }
    .card-footer {
      position: absolute;
      bottom: 10px;
      right: 15px;
      display: grid;
      grid-auto-flow: column;
      gap: 10px;
      .cancel-btn {
        padding: 5px 10px;
        font-size: 15px;
        border: 1px solid;
        border-radius: 4px;
        font-weight: 500;
      }
      .save-btn {
        padding: 5px 10px;
        font-size: 15px;
        border: 1px solid;
        border-radius: 4px;
        font-weight: 500;
        background-color: $N100;
        color: $WHITE;
      }
      .disable {
        background-color: $N20;
      }
    }
  }
}
</style>
